import React, {useState } from 'react';
import { Field, ErrorMessage } from 'formik';
import Input from '../input';
import DropdownComp from "../dropdown";
import { getAllCountries, getStateByCountry } from '../../helpers/countryState';

const RegionFormUae = ({
  options,
  values,
  touched,
  errors,
  handleChange,
  setFieldValue,
  isSubmitting,
}) => {

    const countrydata = getAllCountries();
    const [countries] = useState(countrydata)
    const [states, setStates] = useState([])
    const defaultState = getStateByCountry("India");
 

  return (
    <>
  
       <div className="form-group col-md-12">
                        <label htmlFor="merchentType">Merchant Type</label>
                        <Field as="select" name="merchentType"  className={"form-control"}>
                        <option value="" disabled>Select Merchant Type</option>
                          {options.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage name="merchentType" component="div" className="text-danger"/>
                  
                          </div>
      
                          <div className="form-group col-md-6">
                            <Input
                              id="name"
                              name="name"
                              placeholder="Enter Name"
                              type="text"
                              label={values.merchentType === 'business' ? 'Company Name' : 'Name'}
                              value={values.name}
                              onChange={handleChange}
                              error={touched.name && errors.name}
                              errorText={errors.name}
                              disabled={isSubmitting} />
                          </div>
      
                          <div className="form-group col-md-6">
                            <Input
                              style={{ width: '100%' }}
                              id="address"
                              name="address"
                              placeholder="Registered Address"
                              type="text"
                              label="Registered Address"
                              value={values.address}
                              onChange={handleChange}
                              error={touched.address && errors.address}
                              errorText={errors.address}
                              disabled={isSubmitting}
                          />
                          </div>
      
                          <div className="form-group col-md-6">
                            <Input
                              style={{ width: '100%' }}
                              id="city"
                              name="city"
                              placeholder="City"
                              type="text"
                              label="City"
                              value={values.city}
                              onChange={handleChange}
                              error={touched.city && errors.city}
                              errorText={errors.city}
                              disabled={isSubmitting}
                              />
                          </div>
      
                          <div className="form-group col-md-6">
                            <Input
                              style={{ width: '100%' }}
                              id="pincode"
                              name="pincode"
                              placeholder="Pincode"
                              type="text"
                              label="Pincode"
                              value={values.pincode}
                              onChange={handleChange}
                              error={touched.pincode && errors.pincode}
                              errorText={errors.pincode}
                              disabled={isSubmitting}
                              />
                          </div>
      
                          
      
                          <div className="form-group col-md-6">
                               <DropdownComp
                                name="country"
                                id="country"
                                label="Country"
                                placeholder="Please select"
                                onChange={(selectedValue) => {
                                    setFieldValue("country", selectedValue)
                                    setFieldValue("state", "")
                                    const stateList = getStateByCountry(selectedValue.value)
                                    setStates(stateList)
                                }}
                                value={values.country}
                                options={countries}
                                error={touched.country && errors.country}
                                errorText={errors.country}
                                disabled={isSubmitting}>
                            </DropdownComp>
                          </div>
      
                            <div className="form-group col-md-6">
                            <DropdownComp
                              id="state"
                              name="state"
                              onChange={(selectedValue) => {
                                  setFieldValue("state", selectedValue)
                              }}
                              value={values.state}
                              options={values.country.value === "India" ? defaultState : states}
                              label="State"
                              placeholder="Please select"
                              error={touched.state && errors.state}
                              errorText={errors.state}
                              disabled={isSubmitting || values.country === ''}>
                          </DropdownComp>
                            </div>
      
                          <div className="form-group col-md-6">
                            <Input
                              style={{ width: '100%' }}
                              id="contactName"
                              name="contactName"
                              placeholder="Contact Person Name"
                              type="text"
                              label="Contact Person Name"
                              value={values.contactName}
                              onChange={handleChange}
                              error={touched.contactName && errors.contactName}
                              errorText={errors.contactName}
                              disabled={isSubmitting}
                               />
                          </div>
      
      
                          <div className="form-group col-md-6">
                            <Input
                              style={{ width: '100%' }}
                              id="mobile"
                              name="mobile"
                              placeholder="Mobile"
                              type="text"
                              label="Mobile"
                              value={values.mobile}
                              onChange={handleChange}
                              error={touched.mobile && errors.mobile}
                              errorText={errors.mobile}
                              disabled={isSubmitting}
                             />
                          </div>
      
                          <div className="form-group col-md-6">
                            <Input
                              style={{ width: '100%' }}
                              id="email"
                              name="email"
                              placeholder="Email"
                              type="text"
                              label="Email"
                              value={values.email}
                              onChange={handleChange}
                              error={touched.email && errors.email}
                              errorText={errors.email}
                              disabled={isSubmitting}
                              />
                          </div>

                            {values.merchentType === 'business' && (
                            <div className="form-group col-md-6">
                          
                              <Input
                                style={{ width: '100%' }}
                                id="taxNumber"
                                name="taxNumber"
                                placeholder="Tax Number"
                                type="text"
                                label="VAT Number"
                                value={values.taxNumber}
                                onChange={handleChange}
                                error={touched.taxNumber && errors.taxNumber}
                                errorText={errors.taxNumber}
                                disabled={isSubmitting}
                                  />
                                
                            </div>
                              )}
    </>
  );
};

export default RegionFormUae;
